import React from 'react';
import { Box, Typography } from '@material-ui/core';
import Table from '../../../../../design-system/components/Table/Table';

// `empresa` and `grupo` are not listed: they come from the on-screen selectors
// and are shown once above the table instead of repeated per row.
const previewColumns = [
    { name: 'row_number', label: '#', minWidth: 30, align: 'center' },
    { name: 'empresa', label: 'Empresa', minWidth: 100, align: 'center' },
    { name: 'nombre', label: 'Nombre', minWidth: 80, align: 'center' },
    { name: 'apellidos', label: 'Apellidos', minWidth: 90, align: 'center' },
    { name: 'correo', label: 'Correo', minWidth: 130, align: 'center' },
    { name: 'membresia_label', label: 'Membresía', minWidth: 100, align: 'center' },
    { name: 'plazo_label', label: 'Plazo', minWidth: 90, align: 'center' },
    { name: 'programa_label', label: 'Programa', minWidth: 90, align: 'center' },
    { name: 'addon_label', label: 'Addon', minWidth: 80, align: 'center' },
    { name: 'tag1', label: 'Atributo 1', minWidth: 70, align: 'center' },
    { name: 'tag2', label: 'Atributo 2', minWidth: 70, align: 'center' },
    { name: 'tag3', label: 'Atributo 3', minWidth: 70, align: 'center' },
];

/**
 * @param {object[]} rows - Parsed Excel rows
 * @param {string} companyLabel - Company taken from the on-screen selector
 * @param {string} groupLabel - Group taken from the on-screen selector
 * @param {(row: object, field: string) => string} resolveLabel - Turns a code
 *   into its catalog description so the user can verify what each code means.
 */
const BulkPreviewTable = ({ rows, companyLabel, groupLabel, resolveLabel }) => {
    if (!rows || rows.length === 0) return null;

    const describe = resolveLabel || ((row, field) => row[field] || '');

    const tableRows = rows.map((row, idx) => ({
        ...row,
        id: row.row_number || idx,
        membresia_label: describe(row, 'membresia_sku'),
        plazo_label: describe(row, 'plazo_sku'),
        addon_label: describe(row, 'addon_sku'),
        programa_label: describe(row, 'programa_id'),
    }));

    return (
        <Box mt={2}>
            <Typography variant="subtitle2" gutterBottom>
                {rows.length} registro(s) detectado(s)
            </Typography>
            {(companyLabel || groupLabel) && (
                <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                    Empresa: <strong>{companyLabel || '—'}</strong> · Grupo:{' '}
                    <strong>{groupLabel || '—'}</strong>
                </Typography>
            )}
            <Box style={{ overflowX: 'auto', width: '100%' }}>
                <Table
                    checkboxs={false}
                    maxHeight="400px"
                    columns={previewColumns}
                    rows={tableRows}
                />
            </Box>
        </Box>
    );
};

export default BulkPreviewTable;
